import { render } from "./HumanClone.vue?vue&type=template&id=889bc42a&scoped=true"
import script from "./HumanClone.vue?vue&type=script&lang=js"
export * from "./HumanClone.vue?vue&type=script&lang=js"

import "./HumanClone.vue?vue&type=style&index=0&id=889bc42a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889bc42a"]])

export default __exports__